import React from 'react'
import {
  Box,
  VStack,
  Divider,
  Flex,
  Center,
  Spinner,
  Heading,
  HStack,
} from '@chakra-ui/react'
import { ResetPassword } from '../../../auth/pages/ResetPassword'
import { useGetAccountSettingsQuery } from '../../../auth/api/authApi'
import { ResetUsernameEmail } from '../../../auth/pages/ResetUsernameEmail'
import UserMenu from '../../../../app/components/UserMenu'

export function AccountSettings() {
  const { isLoading } = useGetAccountSettingsQuery()

  if (isLoading) {
    return (
      <Center minH="100vh">
        <Spinner size="xl" />
      </Center>
    )
  }

  return (
    <Flex
      direction="column"
      alignItems="center"
      justifyContent="center"
      maxHeight="100vh"
      px={4}
    >
      <HStack w="100%" justify="space-between" align="center">
        <Heading size="md" mb={4}>
          Account Settings
        </Heading>
        <UserMenu />
      </HStack>
      <Box w="100%" maxW="600px" p={2} rounded="md" alignItems="center">
        <VStack spacing={6} align="stretch">
          <Box>
            <ResetUsernameEmail />
          </Box>
          <Divider />
          <Box>
            <ResetPassword />
          </Box>
        </VStack>
      </Box>
    </Flex>
  )
}
